export default "__VITE_ASSET__ShVi7Fcj__"